<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header {{msgType}}">
    <esp-icon *ngIf="statusIcon" class="modal-status-icon" [ngClass]="'status-' + msgType" [name]="statusIcon" [size]="24"></esp-icon>
    <h2 id="dialogTitle" class="modal-title module-title">{{titleKey|translate}}</h2>
    <button [disabled]="false" type="button" value="Close" class="close" aria-label="Close" title="{{'dialog.box.close.tooltip'|translate}}"
            (click)="reject()">
      <esp-icon name="x"></esp-icon>
    </button>
  </div>
  <div class="modal-body" [innerHtml]="messageKey | translate">

  </div>
  <div class="modal-footer">

    <div class="modal-buttons">
            <span *ngIf="showCancel">
                <breeze-button buttonText="{{cancelLabel|translate}}" id="cancel-btn" [isSecondary]="true" [isDisabled]="cancelDisable"
                               [isAutoFocus]="showCancel" (clicked)="reject()"></breeze-button>
            </span>
      <breeze-button buttonText="{{confirmLabel|translate}}" id="ok-btn" [isPrimary]="true" [isDisabled]="okDisable"
                     (clicked)="confirm()" [isAutoFocus]="!showCancel"></breeze-button>

    </div>
  </div>
</div>

